import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import React from 'react'
import PatientInfo from './PatientInfo'
import { CalendarDays } from 'lucide-react'
import PatientInfoFreeType from './PatientInfoFreetype'

const PatientPastNoteAdmin = ({ patientTreatments, viewPatientDetail, noteID, providerCall = false, noteCallType }) => {
  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role
  return (
    <div>
      {patientTreatments?.length > 0 ? (
        (() => {
          let pastNotes = []

          if (providerCall) {
            pastNotes = patientTreatments.filter((_, index) => index < noteID)
          } else {
            pastNotes = patientTreatments.filter((_, index) => index < noteID)
          }

          // show latest past notes on top
          pastNotes = pastNotes.slice().reverse()

          return pastNotes.length > 0 ? (
            <CAccordion className={`${role == 'provider' ? 'accordion-dark' : 'accordion-light'}`}>
              {pastNotes.map((note, index) => {
                return (
                  <CAccordionItem key={index} itemKey={index} className="mb-2 border rounded shadow-sm" style={{ maxWidth: '100%', overflow: 'auto' }}>
                    <CAccordionHeader>
                      <CalendarDays size={16} className="me-2" style={{ color: 'var(--ui-text-primary)' }} />
                      <span className="fw-semibold me-2" style={{ color: 'var(--ui-text-primary)' }}>{new Date(note.date).toLocaleDateString('en-US')}</span>
                      <span className="text-capitalize" style={{ color: 'var(--ui-text-primary)' }}>Status: {note.status}</span>
                    </CAccordionHeader>

                    <CAccordionBody style={{ maxWidth: '100%', overflow: 'hidden' }}>
                      <PatientInfoFreeType
                        noteCallType={noteCallType}
                        showBreadcrumbs={true}
                        patientData={{
                          ...viewPatientDetail,
                          Status: index == 0 ? 'NewPatient' : 'Follow Up',
                          rishi: 1,
                        }}
                        patientID={viewPatientDetail?.PatientID}
                        dataCallType="edit"
                        setDataId={note?.id}
                        noteID={index}
                        showAllData={false}
                        showNoteView={true}
                      />
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })}
            </CAccordion>
          ) : (
            <div className="text-center" style={{ color: 'gray', fontSize: '14px' }}>
              No Previous Notes Available
            </div>
          )
        })()
      ) : (
        <div className="text-center" style={{ color: 'gray', fontSize: '14px' }}>
          No data available
        </div>
      )}
    </div>
  )
}

export default PatientPastNoteAdmin
